<unity-sidebar-layout [sidebarSpan]="3">
  <div unityMainTile>
    @let agreements = $filteredDataView();
    @let assignedMode = $assignedMode();
    @let overdueMode = $overdueMode();
    <kendo-listview
      class="unity-pager"
      [containerClass]="$containerClass()"
      [itemStyle]="{
        display: 'inline-grid',
      }"
      [data]="agreements"
      [loading]="$isLoading()"
      [pageable]="$pageable()"
      [pageSize]="$pageSize()"
      [skip]="$skip()"
      (pageChange)="handlePageChange($event)">
      <ng-template let-agreement kendoListViewItemTemplate>
        @if (!$isLoading() && $returned() > 0) {
          <unity-card-agreement-shared [agreement]="agreement" [showAgencyName]="$showAgencyName() === true" />
        } @else {
          <div class="k-text-center k-p-xl">
            <h3>No assigned agreements found.</h3>
            <p>
              This may be because no agreements are assigned to you, or your current filters are too narrow. Update your filters or view all
              agreements to continue.
            </p>
            @if (assignedMode === true) {
              <ng-container>
                <button
                  *unityAuthorize="'Agreement:List'"
                  type="button"
                  kendoButton
                  themeColor="secondary"
                  (click)="setSwitchState('is_mine', false)">
                  View All Agreements
                </button>
              </ng-container>
            }
          </div>
        }
      </ng-template>
    </kendo-listview>
  </div>
  <div unitySidebarTile class="sidebar-tile-container">
    <kendo-stacklayout class="filter-title" orientation="horizontal" [align]="{ vertical: 'bottom', horizontal: 'stretch' }">
      <h4 class="filter-header">Filters</h4>
      <span class="filter-header">&nbsp;({{ $count() }} / {{ $total() }})</span>
      <button type="reset" kendoButton themeColor="tertiary" fillMode="link" [svgIcon]="clearIcon" (click)="clearAll()">
        Clear All Filters
      </button>
    </kendo-stacklayout>
    <kendo-panelbar title="Filters" class="filter-body" [selectable]="false" [keepItemContent]="true">
      <!-- Begin switches block -->
      <kendo-panelbar-item title="Agreements" [expanded]="true">
        <ng-template kendoPanelBarContent>
          @if ($showAgreementToggles()) {
            <p *unityAuthorize="'Agreement:List'" class="filter-indent">
              <kendo-radiobutton
                #assignedonly
                class="mode-radio"
                value="Assigned Agreements"
                [checked]="assignedMode === true"
                (checkedChange)="setSwitchState('is_mine', true)" />
              <label kendoLabel class="k-radio-label filter-label" title="Assigned Agreements" [for]="assignedonly"
                >Assigned Agreements</label
              >
            </p>
            <p *unityAuthorize="'Agreement:List'" class="filter-indent">
              <kendo-radiobutton
                #allagreements
                class="mode-radio"
                value="All Agreements"
                [checked]="assignedMode === false"
                (checkedChange)="setSwitchState('is_mine', false)" />
              <label kendoLabel class="k-radio-label filter-label" title="All Agreements" [for]="allagreements">All Agreements</label>
            </p>
          }

          <p class="filter-indent">
            <kendo-checkbox
              #overdueonly
              value="Overdue Only"
              [checkedState]="overdueMode === true"
              (checkedStateChange)="setSwitchState('is_overdue', !overdueMode)" />
            <label kendoLabel class="k-radio-label filter-label" title="Overdue Only" [for]="overdueonly">Overdue Only</label>
          </p>
        </ng-template>
      </kendo-panelbar-item>
      <!-- Begin filter block -->
      @for (fil of $valueStates(); track fil.title) {
        <kendo-panelbar-item [title]="fil.title" [hidden]="fil.hasItems !== true">
          <ng-template kendoPanelBarContent>
            <div class="filter-section-items">
              @let items = fil.items | sort;
              <!-- Filter header -->
              @if (items && items.length > 1) {
                <p #ShowAll class="filter-indent">
                  <kendo-checkbox
                    #chomp
                    [checkedState]="getShowAllState(fil.isAll(), fil.isNone())"
                    (checkedStateChange)="onFilterMasterCheck(fil.key, $event)" />
                  <label kendoLabel class="k-radio-label filter-label" title="Show All" [for]="chomp">Show All</label>
                </p>
              }
              <hr />
              <!-- Filter value boxes -->
              @for (item of items; track item) {
                <p #FilterItem class="filter-indent">
                  <kendo-checkbox #chomp [checkedState]="fil.get(item)" (checkedStateChange)="onFilterItemCheck(fil.key, item)" />
                  <label kendoLabel class="k-radio-label filter-label" [title]="item" [for]="chomp">{{ item }}</label>
                </p>
              }
            </div>
          </ng-template>
        </kendo-panelbar-item>
      }
    </kendo-panelbar>
  </div>
</unity-sidebar-layout>
